import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IOcbRemotePlatform } from '@app/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-remote-platform-picker',
  templateUrl: './remote-platform-picker.component.html',
  styleUrls: ['./remote-platform-picker.component.scss'],
})
export class RemotePlatformPickerComponent implements AfterViewInit {

    @Input()
    public platforms: IOcbRemotePlatform[];

    @Input()
    public isDisabled: boolean;

    @Input()
    public isRequired: boolean = false;

    @Input()
    public selectedItem?: IOcbRemotePlatform;

    @Output()
    public selectedItemChange = new EventEmitter<IOcbRemotePlatform>();

    @ViewChild('selectBox')
    private selectBox: DxSelectBoxComponent;

    public ngAfterViewInit(): void {
        if (this.selectedItem) {
            this.selectBox.value = this.selectedItem.id;
        }
    }

    public selectRemotePlatform(id: string): void {
        this.selectBox.value = id;
    }

    public onSelectedItemChange($event: IOcbRemotePlatform): void {
        if ($event == null && this.isRequired) {
            return;
        }
        this.selectedItemChange.emit($event);
    }
}
